import React, { useState, useEffect, useReducer } from 'react';
import '../components/css/index.css';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const useStyles = makeStyles(theme => ({

}));


export default function Index () {

	const [ activeLink, setActiveLink ] = useState('home-link');

	useEffect(() => {
		switch(activeLink) {
			case 'home-link':
				document.getElementById(activeLink).style.color = '#f0006c';
				document.getElementById('learn-link').style.color= 'white';
				document.getElementById('about-link').style.color= 'white';
				document.getElementById('more-link').style.color= 'white';
			break;

			case 'about-link':

				document.getElementById(activeLink).style.color = '#f0006c';
				document.getElementById('learn-link').style.color= 'white';
				document.getElementById('home-link').style.color= 'white';
				document.getElementById('more-link').style.color= 'white';

			break;

			case 'learn-link':

				document.getElementById(activeLink).style.color = '#f0006c';
				document.getElementById('home-link').style.color= 'white';
				document.getElementById('about-link').style.color= 'white';
				document.getElementById('more-link').style.color= 'white';

			break;

			case 'more-link':

				document.getElementById(activeLink).style.color = '#f0006c';
				document.getElementById('learn-link').style.color= 'white';
				document.getElementById('about-link').style.color= 'white';
				document.getElementById('home-link').style.color= 'white';

			break;

		}

	},[activeLink])

	return (
		<div id='root'>

			<AppBar position='fixed'>
				<Toolbar>
					<a href='#home' className='link-item' id='home-link' onClick={() => setActiveLink('home-link')}>
						<Typography>Home</Typography>
					</a>
					<a href='#learn'className='link-item' id='learn-link' onClick={() => setActiveLink('learn-link')}>
					<Typography >Learn</Typography>
					</a>
					<a href='#about' className='link-item' id='about-link' onClick={() => setActiveLink('about-link')}>
					<Typography>About</Typography>
					</a>
					<a href='#more' className='link-item' id='more-link' onClick={() => setActiveLink('more-link')}>
					<Typography>More</Typography>
					</a>
					<img src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2FphoneImage.png?alt=media&token=325f414d-80b4-453c-9822-691929e8f368" id="phone-img" />
				</Toolbar>
			</AppBar>

			<div id='home'>
			  <video playsInline="playsinline" autoPlay="autoplay" loop="loop" className='video' style={styles.video}>
					<source src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2Fhead_video_v1.mov?alt=media&amp;token=56000baa-f71a-42c5-8f7b-82d4699ddc4a"/>
				</video>
			</div>

			<div className='jumbotron' id='learn'>
			  <div id='quotes'>
			    <blockquote className="blockquote">
			      <p className="mb-0 lead">
			      "This app is just what every family needs, ONE go-to spot for activities to do with our kids, restaurants, and parent's night out events listings."
			      </p>
			      <footer className="blockquote-footer">Maria V., Aurora</footer>
			    </blockquote>

			    <blockquote className="blockquote">
			      <p className="mb-0 lead">
			      "The Funily app is awesome!  Such a great idea to keep families informed on local events and things to do."
			      </p>
			      <footer className="blockquote-footer">Casie B., Wheaton</footer>
			    </blockquote>

			    <blockquote className="blockquote">
			      <p className="mb-0 lead">
			      "I would love to see this app take off!  It's so helpful to us moms."
			      </p>
			      <footer className="blockquote-footer">Holly M., St. Charles</footer>
			    </blockquote>
			  </div>

			</div>
			<div className='jumbotron' id='about'>

			  <div id='about-text'>

			    <h2 className='text-center text-default' id='about-title'>
			      What if there was a way to make it easier for parents to find things to do with their children?
			    </h2>

			    <p className='text-center'>
			      Mike and Rich are two dads who wanted to make it easier for parents to find things to do with their kids. They found that their children were getting bored of doing the same activities every weekend, but it was hard to find things to do. There was no platform out there that helped parents find things to do with their kids and so this app was built!
			    </p>

			    <p className='text-center'>
			    As educators, Mike and Rich recognizes the importance of family time. They also recognize the financial difficulties that families deal with. As a result, they want to make sure that free events are available on the Funily app so that families can enjoy time together without the worry of breaking their budget.
			    </p>

			  </div>
			</div>
			<div className='jumbotron' id='more'>

				<h2 className="text-center" id="more-sub">
					Download the app today and enjoy your time with family.
				</h2>

			</div>

			<div className='jumbotron' id='footer'>

			  <div id='store-container'>

					<a href="https://bit.ly/androidFunily" target="_blank">
				  <img id='google-icon' src="https://myfunily.com/static/media/downloadGooglePlay.f06b9089.png"/>
					</a>

					<a href="https://apple.co/2CVUdYb" target="_blank">
					  <img id='apple-icon' src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2Fapple_icon.png?alt=media&token=e87e283e-59a8-42bd-97b2-851be89b743a"/>
					</a>

			  </div>

			  <p id='rights' className='lead'> ALL RIGHTS RESERVED TO COMPANY 2019</p>

			</div>

		</div>
	)

}


const styles = {
	video: {
		objectFit: 'initial',
		height: "60vh",
		width: '100vw',
		top: 0,
		left: 0,
		marginTop: '25px'
	},
}



// WEBPACK FOOTER //
// ./src/components/index.js